<template>
  <div class="container" style="width:99%;margin-top:-25px;">
	<!--工具栏-->
	<div class="toolbar" style="float:left;padding:10px 12px;width:100%;box-sizing:border-box;background:linear-gradient(180deg,#fff 0%,#f8f9fb 100%);border-bottom:1px solid #e4e7ed;">
		<div class="filter-bar">
		<el-form :inline="true" :model="filters" :size="size" style="display:flex;align-items:center;flex-wrap:wrap;gap:6px;">
			<el-form-item style="margin-bottom:0;" class="filter-item">
				<el-select
					class="sku-select"
					v-model="filters.itemNumber"
					filterable
					remote
					:remote-method="(query) => searchItems(query)"
					:placeholder="$t('TblInvMovementDetail.itemNumber')"
					clearable
					@clear="searchItems('')"
					@visible-change="(visible) => { if (visible) searchItems('') }"
					@change="findPage(null)"
					style="width:200px">
					<el-option
						v-for="item in itemOptions"
						:key="item.itemNumber"
						:value="item.itemNumber"
						:label="item.itemNumber + ' - ' + (item.description || '')">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item style="margin-bottom:0;" class="filter-item">
				<kt-button :label="$t('action.add')" perms="sys:tblInvMovement:add" type="primary" icon="el-icon-plus" @click="handleAdd" />
			</el-form-item>
		</el-form>
		</div>
	</div>
		<!--表格内容栏-->
	<kt-table permsEdit="sys:tblInvMovement:edit" permsDelete="sys:tblInvMovement:delete" permsView="sys:tblInvMovement:view"
            :data="pageResult" :columns="columns" :buttonEdit="$t('action.edit')" :buttonDelete="$t('action.delete')" :batchDelete="$t('action.batchDelete')"
            @findPage="findPage" @handleEdit="handleEdit" @handleDelete="handleDelete">
	</kt-table>
	<!--新增编辑界面-->
	<el-dialog :title="operation?$t('common.add'):$t('common.edit')" width="40%" :visible.sync="editDialogVisible" :close-on-click-modal="false">
		<el-form :model="dataForm" label-width="110px" :rules="dataFormRules" ref="dataForm" :size="size">
			<el-form-item label="" prop="id"  v-if="false">
				<el-input v-model="dataForm.id" auto-complete="off"></el-input>
			</el-form-item>
      <el-form-item :label="$t('TblInvMovementDetail.whId')" prop="whId"  v-if="!dataForm.isPrimaryKey">
        <el-input v-model="dataForm.whId" auto-complete="off" disabled></el-input>
      </el-form-item>
			<el-form-item :label="$t('TblInvMovementDetail.taskId')" prop="taskId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.taskId" auto-complete="off" disabled></el-input>
			</el-form-item>
			<el-form-item :label="$t('TblInvMovementDetail.itemNumber')" prop="itemNumber"  v-if="!dataForm.isPrimaryKey">
        <el-select ref="itemNumber" v-model="dataForm.itemNumber" style="width:100%" class="sku-select" filterable remote :remote-method="searchEditSkus" clearable @clear="searchEditSkus('')">
          <el-option v-for="(sku,index) in this.editSkuOptions" :key="index" :value="sku.optionValue"
                     :label="sku.optionDisplay" @click.native="getItemBaseUom"/>
        </el-select>
			</el-form-item>
      <el-form-item :label="$t('TblInvMovementDetail.lineNumber')" prop="lineNumber"  v-if="this.lineNumberVisible">
        <el-input v-model="dataForm.lineNumber" auto-complete="off"></el-input>
      </el-form-item>
			<el-form-item :label="$t('TblInvMovementDetail.lotNumber')" prop="lotNumber"  v-if="this.lotControl==='Y'">
				<el-input v-model="dataForm.lotNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('TblInvMovementDetail.sourceLocationId')" prop="sourceLocationId"  v-if="!dataForm.isPrimaryKey">
        <el-select ref="sourceLocationId" v-model="dataForm.sourceLocationId" style="width:100%">
          <el-option v-for="(location,index) in this.locationData" :key="index" :value="location.optionValue"
                     :label="location.optionDisplay" @click.native="getLocItemHuIndicate"/>
        </el-select>
			</el-form-item>
      <el-form-item :label="$t('TblInvAdjustmentDetail.huId')" prop="huId"  v-if="this.itemHuIndicate==='H'">
        <el-input v-model="dataForm.huId" auto-complete="off"></el-input>
      </el-form-item>
			<el-form-item :label="$t('TblInvMovementDetail.destLocationId')" prop="destLocationId"  v-if="!dataForm.isPrimaryKey">
        <el-select ref="destLocationId" v-model="dataForm.destLocationId" style="width:100%">
          <el-option v-for="(location,index) in this.DestLocationData" :key="index" :value="location.optionValue"
                     :label="location.optionDisplay"/>
        </el-select>
			</el-form-item>
			<el-form-item :label="$t('TblInvMovementDetail.qty')" prop="qty"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.qty" auto-complete="off"></el-input>
			</el-form-item>
      <el-form-item :label="$t('TblInvMovementDetail.uom')" prop="uom"  v-if="!dataForm.isPrimaryKey">
        <el-select ref="uom" v-model="dataForm.uom" style="width:100%">
          <el-option v-for="(uom,index) in this.baseUomData" :key="index" :value="uom.optionValue"
                     :label="uom.optionDisplay"/>
        </el-select>
      </el-form-item>
			<el-form-item :label="$t('TblInvMovementDetail.lineRemark')" prop="lineRemark"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.lineRemark" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('TblInvMovementDetail.storedAttributeId')" prop="storedAttributeId"  v-if="false">
				<el-input v-model="dataForm.storedAttributeId" auto-complete="off"></el-input>
			</el-form-item>
      <el-form-item :label="$t('attributes.genericAttrShow1')" prop="genericAttrShow1" v-if="this.attributesCount>0">
        <el-input v-model="dataForm.genericAttrShow1" auto-complete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="" prop="genericAttrValue1" v-if="this.attributesCount>0">
        <el-input v-model="dataForm.genericAttrValue1" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('attributes.genericAttrShow2')" prop="genericAttrShow2" v-if="this.attributesCount>1">
        <el-input v-model="dataForm.genericAttrShow2" auto-complete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="" prop="genericAttrValue2" v-if="this.attributesCount>1">
        <el-input v-model="dataForm.genericAttrValue2" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('attributes.genericAttrShow3')" prop="genericAttrShow3" v-if="this.attributesCount>2">
        <el-input v-model="dataForm.genericAttrShow3" auto-complete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="" prop="genericAttrValue3" v-if="this.attributesCount>2">
        <el-input v-model="dataForm.genericAttrValue3" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('attributes.genericAttrShow4')" prop="genericAttrShow4" v-if="this.attributesCount>3">
        <el-input v-model="dataForm.genericAttrShow4" auto-complete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="" prop="genericAttrValue4" v-if="this.attributesCount>3">
        <el-input v-model="dataForm.genericAttrValue4" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('attributes.genericAttrShow5')" prop="genericAttrShow5" v-if="this.attributesCount>4">
        <el-input v-model="dataForm.genericAttrShow5" auto-complete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="" prop="genericAttrValue5" v-if="this.attributesCount>4">
        <el-input v-model="dataForm.genericAttrValue5" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('attributes.genericAttrShow6')" prop="genericAttrShow6" v-if="this.attributesCount>5">
        <el-input v-model="dataForm.genericAttrShow6" auto-complete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="" prop="genericAttrValue6" v-if="this.attributesCount>5">
        <el-input v-model="dataForm.genericAttrValue6" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('attributes.genericAttrShow7')" prop="genericAttrShow7" v-if="this.attributesCount>6">
        <el-input v-model="dataForm.genericAttrShow7" auto-complete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="" prop="genericAttrValue7" v-if="this.attributesCount>6">
        <el-input v-model="dataForm.genericAttrValue7" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('attributes.genericAttrShow8')" prop="genericAttrShow8" v-if="this.attributesCount>7">
        <el-input v-model="dataForm.genericAttrShow8" auto-complete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="" prop="genericAttrValue8" v-if="this.attributesCount>7">
        <el-input v-model="dataForm.genericAttrValue8" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('attributes.genericAttrShow9')" prop="genericAttrShow9" v-if="this.attributesCount>8">
        <el-input v-model="dataForm.genericAttrShow9" auto-complete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="" prop="genericAttrValue9" v-if="this.attributesCount>8">
        <el-input v-model="dataForm.genericAttrValue9" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('attributes.genericAttrShow10')" prop="genericAttrShow10" v-if="this.attributesCount>9">
        <el-input v-model="dataForm.genericAttrShow10" auto-complete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="" prop="genericAttrValue10" v-if="this.attributesCount>9">
        <el-input v-model="dataForm.genericAttrValue10" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('attributes.genericAttrShow11')" prop="genericAttrShow11" v-if="this.attributesCount>10">
        <el-input v-model="dataForm.genericAttrShow11" auto-complete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="" prop="genericAttrValue11" v-if="this.attributesCount>10">
        <el-input v-model="dataForm.genericAttrValue11" auto-complete="off"></el-input>
      </el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button :size="size" @click.native="editDialogVisible = false">{{$t('action.cancel')}}</el-button>
			<el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">{{$t('action.submit')}}</el-button>
		</div>
	</el-dialog>
  </div>
</template>

<script>
import KtTable from "@/views/Core/KtTable"
import KtButton from "@/views/Core/KtButton"
import { format } from "@/utils/datetime"
export default {
  name:'TblInvMovementDetail',
	components:{
			KtTable,
			KtButton
	},
	data() {
		return {
			size: 'small',
      baseUomData:Object,
      skuData:Object,
      editSkuOptions: [],
      locationData:Object,
      destLocationData:[],
      clientCode:'',
      lotControl:'',
      attributesCount:0,
      itemHuIndicate:'',
      lineNumberVisible: false, // 行号是否显示
      filters: {
        taskId: '',
        whId: '',
        clientCode: '',
        itemNumber: ''
      },
      itemOptions: [],
			columns: [
				{prop:"id", label:"TblInvMovementDetail.id", minWidth:100},
        {prop:"whId", label:"TblInvMovementDetail.whId", minWidth:100},
				{prop:"taskId", label:"TblInvMovementDetail.taskId", minWidth:100},
        {prop:"lineNumber", label:"TblInvMovementDetail.lineNumber", minWidth:100},
        {prop:"status", label:"TblInvMovementDetail.status", minWidth:100},
				{prop:"itemNumber", label:"TblInvMovementDetail.itemNumber", minWidth:100},
        {prop:"description", label:"common.itemDescription", minWidth:120},
				{prop:"lotNumber", label:"TblInvMovementDetail.lotNumber", minWidth:100},
				{prop:"sourceLocationId", label:"TblInvMovementDetail.sourceLocationId", minWidth:100},
        {prop:"huId", label:"TblInvMovementDetail.huId", minWidth:100},
				{prop:"destLocationId", label:"TblInvMovementDetail.destLocationId", minWidth:100},
				{prop:"qty", label:"TblInvMovementDetail.qty", minWidth:100},
        {prop:"uom", label:"TblInvMovementDetail.uom", minWidth:100},
				{prop:"lineRemark", label:"TblInvMovementDetail.lineRemark", minWidth:100},
				{prop:"storedAttributeId", label:"TblInvMovementDetail.storedAttributeId", minWidth:100},
        {prop:"genericAttrValue1", label:"attributes.genericAttrValue1", minWidth:100, display:false},
        {prop:"genericAttrValue2", label:"attributes.genericAttrValue2", minWidth:100, display:false},
        {prop:"genericAttrValue3", label:"attributes.genericAttrValue3", minWidth:100, display:false},
        {prop:"genericAttrValue4", label:"attributes.genericAttrValue4", minWidth:100, display:false},
        {prop:"genericAttrValue5", label:"attributes.genericAttrValue5", minWidth:100, display:false},
        {prop:"genericAttrValue6", label:"attributes.genericAttrValue6", minWidth:100, display:false},
        {prop:"genericAttrValue7", label:"attributes.genericAttrValue7", minWidth:100, display:false},
        {prop:"genericAttrValue8", label:"attributes.genericAttrValue8", minWidth:100, display:false},
        {prop:"genericAttrValue9", label:"attributes.genericAttrValue9", minWidth:100, display:false},
        {prop:"genericAttrValue10", label:"attributes.genericAttrValue10", minWidth:100, display:false},
        {prop:"genericAttrValue11", label:"attributes.genericAttrValue11", minWidth:100, display:false},
        {prop:"genericAttrShow1", label:"attributes.genericAttrShow1", minWidth:100},
        {prop:"genericAttrShow2", label:"attributes.genericAttrShow2", minWidth:100},
        {prop:"genericAttrShow3", label:"attributes.genericAttrShow3", minWidth:100},
        {prop:"genericAttrShow4", label:"attributes.genericAttrShow4", minWidth:100},
        {prop:"genericAttrShow5", label:"attributes.genericAttrShow5", minWidth:100},
        {prop:"genericAttrShow6", label:"attributes.genericAttrShow6", minWidth:100},
        {prop:"genericAttrShow7", label:"attributes.genericAttrShow7", minWidth:100},
        {prop:"genericAttrShow8", label:"attributes.genericAttrShow8", minWidth:100},
        {prop:"genericAttrShow9", label:"attributes.genericAttrShow9", minWidth:100},
        {prop:"genericAttrShow10", label:"attributes.genericAttrShow10", minWidth:100},
        {prop:"genericAttrShow11", label:"attributes.genericAttrShow11", minWidth:100},
			],
			pageRequest: { pageNum: 1, pageSize: 8 },
			pageResult: {},

			operation: false, // true:新增, false:编辑
			editDialogVisible: false, // 新增编辑界面是否显示
			editLoading: false,
      dataFormRules: {
        qty: [
          { required: true, message: this.$t('common.dataFormRules.quantityRequired'), trigger: 'blur' },
          { pattern : /(^[1-9](\d+)?(\.(?!.*0$)\d{1,3})?$)|(^\d\.(?!.*0$)\d{1,3}$)/,message: this.$t('common.dataFormRules.quantityGreaterZeroPattern'), trigger: 'blur' }
        ],
        lineNumber: [
          { required: true, message: this.$t('common.dataFormRules.lineNumberRequired'), trigger: 'blur' },
          { pattern : /^[1-9]d*$/,message: this.$t('common.dataFormRules.lineNumberPattern'), trigger: 'blur' }
        ],
        itemNumber: [
          { required: true, message: this.$t('common.dataFormRules.required'), trigger: 'blur' },
        ],
        sourceLocationId: [
          { required: true, message: this.$t('common.dataFormRules.required'), trigger: 'blur' },
        ],
        destLocationId: [
          { required: true, message: this.$t('common.dataFormRules.required'), trigger: 'blur' },
        ],
        uom: [
          { required: true, message: this.$t('common.dataFormRules.required'), trigger: 'blur' },
        ]
      },
			// 新增编辑界面数据
			dataForm: {
				id: null,
				taskId: null,
				whId: null,
				itemNumber: null,
				lotNumber: null,
				sourceLocationId: null,
        huId: null,
				destLocationId: null,
				qty: null,
        uom: null,
				lineRemark: null,
				lineNumber: null,
				storedAttributeId: null,
        genericAttrValue1: null,
        genericAttrValue2: null,
        genericAttrValue3: null,
        genericAttrValue4: null,
        genericAttrValue5: null,
        genericAttrValue6: null,
        genericAttrValue7: null,
        genericAttrValue8: null,
        genericAttrValue9: null,
        genericAttrValue10: null,
        genericAttrValue11: null,
        genericAttrShow1: null,
        genericAttrShow2: null,
        genericAttrShow3: null,
        genericAttrShow4: null,
        genericAttrShow5: null,
        genericAttrShow6: null,
        genericAttrShow7: null,
        genericAttrShow8: null,
        genericAttrShow9: null,
        genericAttrShow10: null,
        genericAttrShow11: null,
}
}
	},
	methods: {
    getParentParams: function () {
      this.filters.taskId=this.$route.query.taskId
      this.filters.whId=this.$route.query.whId
      this.filters.clientCode=this.$route.query.clientCode
      if (this.filters.whId) sessionStorage.setItem('tim_whId', this.filters.whId)
      if (this.filters.taskId) sessionStorage.setItem('tim_taskId', this.filters.taskId)
      if (this.filters.clientCode) sessionStorage.setItem('tim_clientCode', this.filters.clientCode)
      this.getLocation()
    },
    //获取商品基本单位
    getItemBaseUom: function (){
      let whId=this.dataForm.whId
      let itemNumber=this.dataForm.itemNumber
      let objUom = {whId:whId,itemNumber:itemNumber}
      this.$wmsApi.globalOption.getItemBaseUom(objUom)
        .then(res =>
        {
          //请求返回的数据
          this.baseUomData = res.data
          this.getItemLotCtlAttrCollection()
        })
    },
    //获取库位托盘标识
    getLocItemHuIndicate: function (){
      let whId=this.dataForm.whId
      let locationId=this.dataForm.sourceLocationId

      let objReq = {whId:whId,locationId:locationId}
      this.$wmsApi.globalOption.getLocItemHuIndicate(objReq).then(res =>
      {
        //请求返回的数据
        if (JSON.stringify(res.data) !== '[]') {
          this.itemHuIndicate = res.data[0]["itemHuIndicate"]
          this.getDestinationLocation()
        }
else {
          this.$message({message: this.$t("common.message.fail") + this.$t("common.message.responseIsEmpty"), type: 'error'})
        }
      })
    },
    //获取商品批号控制和动态属性集合ID
    getItemLotCtlAttrCollection: function (){
      let whId=this.dataForm.whId
      let itemNumber=this.dataForm.itemNumber

      let objReq = {whId:whId,itemNumber:itemNumber}
      this.$wmsApi.globalOption.getItemLotCtlAttrCollection(objReq).then(res =>
      {
        //请求返回的数据
        if (JSON.stringify(res.data) !== '[]') {
          this.lotControl = res.data[0]["lotControl"]
          this.clientCode = res.data[0]["clientCode"]
          let attributeCollectionId = res.data[0]["attributeCollectionId"]
          if (attributeCollectionId!==null) {
            this.getItemAttributeTypes()
          }
else {
            this.attributesCount=0
            this.dataForm.storedAttributeId=null
          }
        }
else {
          this.$message({message: this.$t("common.message.fail") + this.$t("attributes.message.notFoundItem"), type: 'error'})
        }
      })
    },
    //获取商品批号控制和动态属性
    getItemAttributeTypes: function (){
      let whId=this.dataForm.whId
      let itemNumber=this.dataForm.itemNumber

      let objReq = {whId:whId,itemNumber:itemNumber}
      this.$wmsApi.globalOption.getItemAttributeTypes(objReq).then(res =>
      {
        //请求返回的数据
        if (JSON.stringify(res.data) !== '[]') {
          let rowCount = 0
          for (let i = 0; i < res.data.length; i++) {
            if (i === 0 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow1 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
if (i === 1 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow2 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
if (i === 2 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow3 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
if (i === 3 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow4 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
if (i === 4 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow5 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
if (i === 5 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow6 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
if (i === 6 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow7 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
if (i === 7 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow8 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
if (i === 8 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow9 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
if (i === 9 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow10 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
if (i === 10 & res.data[i]["attributeType"] !== null) {
              this.dataForm.genericAttrShow11 = res.data[i]["attributeType"]
              rowCount = rowCount + 1;
            }
          }
this.attributesCount = rowCount
        }
else {
          this.$message({message: this.$t("common.message.fail") + this.$t("attributes.message.notFoundItemAttributes"), type: 'error'})
        }
      })
    },
    // 有动态属性时，必须全部填写或全部为空
    hasEmptyVisibleAttr: function() {
      if (this.attributesCount === 0) return false
      let hasEmpty = false
      let hasFilled = false
      for (let i = 1; i <= this.attributesCount; i++) {
        let val = this.dataForm['genericAttrValue' + i]
        if (val === null || val === '') {
          hasEmpty = true
        }
else {
          hasFilled = true
        }
      }
      // 禁止部分填写：要么全空，要么全填
      if (hasEmpty && hasFilled) return true
      return false
    },
    getStoredAttributeId: function () {
      if(this.attributesCount>0)
      {
        let whId=this.dataForm.whId
        let itemNumber=this.dataForm.itemNumber
        let genericAttrShow1=this.dataForm.genericAttrShow1
        let genericAttrShow2=this.dataForm.genericAttrShow2
        let genericAttrShow3=this.dataForm.genericAttrShow3
        let genericAttrShow4=this.dataForm.genericAttrShow4
        let genericAttrShow5=this.dataForm.genericAttrShow5
        let genericAttrShow6=this.dataForm.genericAttrShow6
        let genericAttrShow7=this.dataForm.genericAttrShow7
        let genericAttrShow8=this.dataForm.genericAttrShow8
        let genericAttrShow9=this.dataForm.genericAttrShow9
        let genericAttrShow10=this.dataForm.genericAttrShow10
        let genericAttrShow11=this.dataForm.genericAttrShow11
        let genericAttrValue1=this.dataForm.genericAttrValue1
        let genericAttrValue2=this.dataForm.genericAttrValue2
        let genericAttrValue3=this.dataForm.genericAttrValue3
        let genericAttrValue4=this.dataForm.genericAttrValue4
        let genericAttrValue5=this.dataForm.genericAttrValue5
        let genericAttrValue6=this.dataForm.genericAttrValue6
        let genericAttrValue7=this.dataForm.genericAttrValue7
        let genericAttrValue8=this.dataForm.genericAttrValue8
        let genericAttrValue9=this.dataForm.genericAttrValue9
        let genericAttrValue10=this.dataForm.genericAttrValue10
        let genericAttrValue11=this.dataForm.genericAttrValue11

        this.dataForm.storedAttributeId=null
        
        if (this.hasEmptyVisibleAttr()) {
          this.$message({message: this.$t("attributes.message.itemAttributesIsEmpty"), type: 'error'})
          return
        }
let objReq = {itemNumber:itemNumber,whId:whId,genericAttrValue1:genericAttrValue1,genericAttrValue2:genericAttrValue2,genericAttrValue3:genericAttrValue3,genericAttrValue4:genericAttrValue4,genericAttrValue5:genericAttrValue5,genericAttrValue6:genericAttrValue6,genericAttrValue7:genericAttrValue7,genericAttrValue8:genericAttrValue8,genericAttrValue9:genericAttrValue9,genericAttrValue10:genericAttrValue10,genericAttrValue11:genericAttrValue11}
        this.$wmsApi.globalOption.getStoredAttributeId(objReq).then(res =>{
          //请求返回的数据
          if(res.code == 200)
          {
            // if(res.data[0]!==null)
            if(JSON.stringify(res.data) !== '{}')
            {
              // if(res.data[0]["storedAttributeId"]!==null)
              if(res.data["storedAttributeId"]!==null)
              {
                this.dataForm.storedAttributeId=res.data["storedAttributeId"]
                this.findAvailableStockQty()
              }
else {
                this.$message({message: this.$t("common.message.fail") + this.$t("attributes.message.generateAttributesFail"),type: 'error'})
              }
            }
            
          }
else {
            this.$message({message: this.$t("common.message.fail") + res.msg, type: 'error'})
          }
        })
      }
else {
        //如果商品未设置动态属性，则直接保存
        this.findAvailableStockQty()
      }
    },
    //获取库位下拉列表
    getLocation: function (){
      let whId=this.filters.whId
      let objLocation = {whId:whId}
      this.$wmsApi.globalOption.getLocation(objLocation)
        .then(res =>
        {
          //请求返回的数据
          this.locationData = res.data
          this.findPage(null)
        })
    },
    //获取目标库位下拉列表
    getDestinationLocation: function (){
      let whId=this.dataForm.whId
      let clientCode=this.clientCode
      let locationId=this.dataForm.sourceLocationId
      if (!locationId) return
      let objLocation = {whId:whId,clientCode:clientCode,locationId:locationId}
      this.$wmsApi.globalOption.getDestinationLocation(objLocation)
        .then(res =>
        {
          //请求返回的数据
          this.DestLocationData = res.data
        })
    },
    //获取SKU下拉列表
    getSku: function (){
      let whId=this.filters.whId
      let clientCode=this.selectedClient
      let objSku = {whId:whId,clientCode:clientCode}
      this.$wmsApi.globalOption.getSku(objSku)
        .then(res =>
        {
          //请求返回的数据
          this.skuData = res.data
          this.editSkuOptions = res.data
          this.findPage(null)
        })
    },
		// 获取分页数据
		findPage: function (data) {
			if(data !== null && data.pageRequest) {
				this.pageRequest.pageNum = data.pageRequest.pageNum
				this.pageRequest.pageSize = data.pageRequest.pageSize
			}
			let localeId=sessionStorage.getItem('localeId')
      let whId=this.filters.whId
      let taskId=this.filters.taskId
      let itemNumber=this.filters.itemNumber

      if(itemNumber == null || itemNumber == "") {
        itemNumber = "%"
      }
this.pageRequest.columnFilters = {whId:{name:"whId",value:whId},taskId: {name:'taskId', value:taskId},localeId: {name:'localeId', value:localeId},itemNumber:{name:'itemNumber', value:itemNumber}}
			this.$wmsApi.tblInvMovementDetail.findPage(this.pageRequest).then((res) => {
				this.pageResult = res.data
			}).then(data!=null?data.callback:'')
		},
		// 批量删除
		handleDelete: function (data) {
			this.$wmsApi.tblInvMovementDetail.batchDelete(data.params).then(data!=null?data.callback:'')
		},
		// 显示新增界面
		handleAdd: function () {
      this.lineNumberVisible = true
			this.editDialogVisible = true
			this.operation = true
			this.dataForm = {
				id: null,
				taskId: null,
				whId: null,
				itemNumber: null,
				lotNumber: null,
				sourceLocationId: null,
        huId: null,
				destLocationId: null,
				qty: null,
        uom: null,
				lineRemark: null,
				lineNumber: null,
				storedAttributeId: null,
        genericAttrValue1: null,
        genericAttrValue2: null,
        genericAttrValue3: null,
        genericAttrValue4: null,
        genericAttrValue5: null,
        genericAttrValue6: null,
        genericAttrValue7: null,
        genericAttrValue8: null,
        genericAttrValue9: null,
        genericAttrValue10: null,
        genericAttrValue11: null,
        genericAttrShow1: null,
        genericAttrShow2: null,
        genericAttrShow3: null,
        genericAttrShow4: null,
        genericAttrShow5: null,
        genericAttrShow6: null,
        genericAttrShow7: null,
        genericAttrShow8: null,
        genericAttrShow9: null,
        genericAttrShow10: null,
        genericAttrShow11: null,
			}
			this.dataForm.whId=this.filters.whId
      this.dataForm.taskId=this.filters.taskId
      this.clientCode=this.filters.clientCode
      this.lotControl='N'
      this.attributesCount=0
      this.searchEditSkus('')
		},
		// 显示编辑界面
		handleEdit: function (params) {
      this.lineNumberVisible = false
      this.editDialogVisible = true
      this.operation = false
      this.lotControl='N'
      this.attributesCount=0
      this.dataForm = Object.assign({}, params.row)
      this.searchEditSkus('')
      this.getLocItemHuIndicate()
      this.getItemLotCtlAttrCollection()
      this.getItemBaseUom()
		},
    // 保存新增或编辑的数据
    save: function () {
      let params = Object.assign({}, this.dataForm)
      this.$wmsApi.tblInvMovementDetail.save(params).then((res) => {
        if(res.code == 200) {
          if(res.data == 0) {
            this.$message({message: this.$t("common.message.fail") + this.$t("common.message.notAllowEditAndAdd"), type: 'error'})
          }
else {
            this.$message({message: this.$t("common.message.success") + '', type: 'success'})
          }
        }
else {
          this.$message({message: this.$t("common.message.fail") + res.msg, type: 'error'})
        }
this.$refs['dataForm'].resetFields()
        this.editDialogVisible = false
        this.findPage(null)
      })
    },
		// 编辑
    submitForm: function () {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("common.message.confirmSubmission")+'', this.$t("common.message.prompt")+'', {confirmButtonText: this.$t("common.message.confirm")+'', cancelButtonText: this.$t("common.message.cancel")+''}).then(() => {

            if(this.lotControl==='Y')
            {
              if(this.dataForm.lotNumber===null || this.dataForm.lotNumber==='' || this.dataForm.expirationDate===null || this.dataForm.expirationDate==='')
              {
                this.$message({message: this.$t("common.message.fail") + this.$t("TblInvMovementDetail.message.lotNotEmpty"), type: 'error'})
                return
              }
            }
else {
              this.dataForm.lotNumber=null
            }
if(this.itemHuIndicate==='H')
            {
              if(this.dataForm.huId===null || this.dataForm.huId==='')
              {
                this.$message({message: this.$t("common.message.fail") + this.$t("TblInvMovementDetail.message.huNotAllowEmpty"), type: 'error'})
                return
              }
            }
else {
              this.dataForm.huId=null
            }
this.findDuplicateLine()
          })
        }
      })
    },
    findDuplicateLine: function () {
      if (this.lineNumberVisible){
        let params = Object.assign({}, this.dataForm)
        this.$wmsApi.tblInvMovementDetail.findDuplicateLine(params).then((res) => {
          if(res.code == 200) {
            if (JSON.stringify(res.data) !== '{}' && res.data!==null) {
              this.$message({message: this.$t("common.message.fail") + this.$t("common.message.duplicateLine"), type: 'error'})
              return
            }
          }
else {
            this.$message({message: this.$t("common.message.fail") + res.msg, type: 'error'})
            return
          }
        })
      }
this.getStoredAttributeId()
    },
    findAvailableStockQty: function () {
      let objReq={whId:this.dataForm.whId,locationId:this.dataForm.sourceLocationId,itemNumber:this.dataForm.itemNumber,lotNumber:this.dataForm.lotNumber,huId:this.dataForm.huId,storedAttributeId:this.dataForm.storedAttributeId}
      this.$wmsApi.tStoredItem.findAvailableStockQty(objReq).then((res) => {
        if(res.code !== 200) {
          this.$message({message: this.$t("common.message.fail") + res.msg, type: 'error'})
          return
        }
if (JSON.stringify(res.data) === '[]') {
          this.$message({message: this.$t("common.message.fail") + this.$t("common.message.notAvailableStock"), type: 'error'})
          return
        }
if(res.data[0]["actualQty"]===null) {
          this.$message({message: this.$t("common.message.fail") + this.$t("common.message.notAvailableStock"), type: 'error'})
          return
        }
let availableQty = res.data[0]["actualQty"]
        if (availableQty === 0) {
          this.$message({
            message: this.$t("common.message.fail") + this.$t("common.message.notAvailableStock"),
            type: 'error'
          })
          return
        }
if(availableQty<this.dataForm.qty) {
          this.$message({message: this.$t("common.message.fail") + this.$t("common.message.greaterThanAvailableStock"), type: 'error'})
          return
        }
this.save()
      })
    },
    searchItems(query) {
      if (!this.filters.whId) return
      this.$wmsApi.globalOption.searchItems({ whId: this.filters.whId, keyword: query }).then(res => {
        this.itemOptions = res.data || []
      })
    },
    searchEditSkus(query) {
      if (!this.filters.whId) return
      this.$wmsApi.globalOption.searchItems({ whId: this.filters.whId, keyword: query }).then(res => {
        this.editSkuOptions = (res.data || []).map(item => ({
          optionValue: item.itemNumber,
          optionDisplay: (item.itemNumber || '') + ' - ' + (item.description || '')
        }))
      })
    },
  // 时间格式化
    dateFormat: function (row, column, cellValue, index){
      return format(row[column.property])
    }
	},
  activated: function () {
    // 兜底：如果 route query 为空，从 sessionStorage 恢复
    if (!this.$route.query.whId && !this.$route.query.taskId && sessionStorage.getItem('tim_whId')) {
      this.filters.whId = sessionStorage.getItem('tim_whId')
      this.filters.taskId = sessionStorage.getItem('tim_taskId')
      this.filters.clientCode = sessionStorage.getItem('tim_clientCode')
      this.getLocation()
    }
else if (this.$route.query.whId || this.$route.query.taskId) {
      this.getParentParams()
    }
  },
	mounted() {
	}
}
</script>

<style scoped>
/* 商品编码下拉框显示箭头图标 */
.sku-select.el-select.is-focused .el-select__caret {
  opacity: 1 !important;
  transform: rotateZ(180deg);
  color: #c0c4cc;
  font-size: 14px;
}

/* 工业软件风格 - 工具栏整体布局 */
.toolbar {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
}

/* 筛选条件区 - 工业软件卡片风格 */
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8f9fb 0%, #ffffff 100%);
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  margin-bottom: 10px;
}

/* 筛选分组 */
.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 10px;
  border-right: 1px solid #dcdfe6;
  margin-right: 6px;
}

/* 筛选分隔线 */
.filter-divider {
  width: 1px;
  height: 24px;
  background: linear-gradient(180deg, transparent 0%, #dcdfe6 50%, transparent 100%);
  margin: 0 4px;
}

/* 单个筛选项 */
.filter-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* 筛选标签 */
.filter-label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
  white-space: nowrap;
  min-width: 52px;
  text-align: right;
}

/* 操作按钮区 */
.action-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 6px;
}

/* 响应式 - 小屏幕 */
@media screen and (max-width: 1200px) {
  .filter-bar {
    padding: 8px 10px;
  }
  .filter-label {
    display: none;
  }
  .filter-group {
    border-right: none;
    padding-right: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Wms/TblInvMovementDetail.vue